(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/models/round.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/models/round.js');

'use strict';

svs.game_results.models.Round = Backbone.Model.extend({
  initialize(attributes) {
    const paths = [];
    paths.push("/draw/1/".concat(attributes.product, "/draws/").concat(attributes.drawNumber));
    paths.push("/draw/1/".concat(attributes.product, "/draws/forecast/").concat(attributes.drawNumber));
    paths.push("/draw/1/".concat(attributes.product, "/draws/").concat(attributes.drawNumber, "/result"));
    svs.core.jupiter.get(paths, response => {
      let draw;
      let forecast;
      if (response.responses[1].forecastResult) {
        forecast = response.responses[1].forecastResult;
        const drawState = forecast.drawState;
        const roundIsLive = drawState >= svs.game_results.constants.drawStates.CLOSED && drawState < svs.game_results.constants.drawStates.FINALIZED;
        this.set('roundIsLive', roundIsLive);
        this.set('drawState', drawState, {
          silent: true
        });
        if (response.responses[0].draw) {
          const rowPrice = response.responses[0].draw.rowPrice;
          forecast.winresult.forEach(currentForecast => {
            currentForecast.winAmount = Math.floor(parseFloat(svs.utils.format.CurrencyFromJupiterString(currentForecast.winValue) * parseInt(rowPrice, 10)));
          });
        }
        this.set('forecast', forecast);
        this.set('winresult', forecast.winresult);
      }
      if (response.responses[2].result) {
        this.set('result', response.responses[2].result);
      }
      if (response.responses[0].draw) {
        draw = response.responses[0].draw;
        if (draw.drawStateId < svs.game_results.constants.drawStates.CLOSED) {
          this.set('isBeforeStart', true);
        }

        if (draw.productId === svs.game_results.constants.productId.BOMBEN) {
          draw.currentNetSale = draw.currentNetSales;
          draw.drawEvents = draw.events;
        }
        if (draw.sport && draw.sport.type === svs.components.sport.sportTypes.SportTypes.Trotting) {
          this.set('isTrotting', true);
        }
        this.set('draw', draw);
      }
      const currentProduct = this.get('product');
      const currentDrawNumber = this.get('drawNumber');
      const liveResultsSocketPath = "/draw/1/".concat(currentProduct, "/draws/").concat(currentDrawNumber);
      const forecastSocketPath = "/draw/1/".concat(currentProduct, "/draws/forecast/").concat(currentDrawNumber);
      svs.core.socket.subscribe(liveResultsSocketPath, this.liveResultsSocketUpdate, this, false);
      svs.core.socket.subscribe(forecastSocketPath, this.forecastSocketUpdate, this, false);
    });
  },
  setFinalResult(forecastResult) {
    const currentProduct = this.get('product');
    const path = "/draw/1/".concat(currentProduct, "/draws/").concat(forecastResult.drawnum, "/result");
    svs.core.jupiter.get(path, response => {
      if (!response.error) {
        this.set('result', response.result);
      }
      this.updateForecast(forecastResult);
    });
  },
  updateForecast(forecastResult) {
    this.set('forecast', forecastResult);
    this.set('changes', forecastResult.changes, {
      silent: true
    });
    this.set('resultIdx', forecastResult.resultIdx);
    this.set('drawState', forecastResult.drawState);
  },
  forecastSocketUpdate(value) {
    if (value.forecastResult) {
      const forecastResult = value.forecastResult;
      if (this.get('isBeforeStart') && forecastResult.drawState >= svs.game_results.constants.drawStates.CLOSED) {
        this.set('isBeforeStart', false);
      }
      const roundIsLive = forecastResult.drawState >= svs.game_results.constants.drawStates.CLOSED && forecastResult.drawState < svs.game_results.constants.drawStates.FINALIZED;
      this.set('roundIsLive', roundIsLive);
      if (forecastResult.drawState === svs.game_results.constants.drawStates.FINALIZED) {
        this.setFinalResult(forecastResult);
      } else {
        this.updateForecast(forecastResult);
      }
    }
  },
  liveResultsSocketUpdate(value) {
    if (value.draw) {
      this.set('liveResults', value.draw);
    }
  }
});

 })(window);